import { render, staticRenderFns } from "./ClientHedgingReport.vue?vue&type=template&id=53e4238e"
import script from "./ClientHedgingReport.vue?vue&type=script&lang=js"
export * from "./ClientHedgingReport.vue?vue&type=script&lang=js"
import style0 from "./ClientHedgingReport.vue?vue&type=style&index=0&id=53e4238e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports